import React, { Component } from "react";

// @ts-ignore
import cn from "classnames";
import Markdown from "../../../components/Markdown";
import {
  workflowStepCN,
  workflowStepWaitingCN,
  workflowStepIdLabelCN,
  workflowStepContentCN,
  workflowStepContentTitleCN,
  workflowStepContentDescriptionCN,
} from "./styles";

import type { WorkflowStep } from "../../../../redux/modules/workflow/reducer";

interface WorkflowStepSuccessfulProps {
  step: WorkflowStep,
};

export default class WorkflowStepWaiting extends Component<WorkflowStepSuccessfulProps> {
  render() {
    const { id, title, descriptionMd } = this.props.step;

    return (
      <div
        id={`workflow-step-${id}`}
        className={cn(workflowStepCN, workflowStepWaitingCN)}
      >
        <div className={workflowStepIdLabelCN}>{id}</div>
        <div className={workflowStepContentCN}>
          <div className={workflowStepContentTitleCN}>{title}</div>
          <div className={workflowStepContentDescriptionCN}>
            <Markdown text={descriptionMd} />
          </div>
        </div>
      </div>
    );
  }
}
